module.exports = __webpack_public_path__ + "static/media/ciniphilia_react_platform.40ff0ca4.gif";